const layout = {
  header: {
    changeView: {
      toasts: {
        success: 'Site successfully changed',
        failure: 'Unexpected error occurred',
      },
    },
  },

  sideBar: {
    menu: {
      home: {
        title: 'Home',
      },
      parents: {
        title: 'Parents',
      },
      trips: {
        title: 'Trips',
        children: {
          trips: 'Trips',
          timeline: 'Timeline',
        },
      },
      jobs: {
        title: 'Bookings',
        children: {
          jobs: 'Bookings',
          calendar: 'Calendar',
          passengers: 'Passengers',
          students: 'Students',
          employees: 'Employees',
          profiles: 'Profiles',
          parents: 'Parents',
          caregivers: 'Caregivers',
        },
      },
      drivers: {
        title: 'Drivers',
        children: {
          drivers: 'Drivers',
          onlineDrivers: 'Online Drivers',
          driverShifts: 'Driver Shifts',
          livemap: 'Live Map',
        },
      },
      vehicles: {
        title: 'Vehicles',
      },
      integrations: {
        title: 'Integrations',
      },
      automations: {
        title: 'Automations',
      },
      reports: {
        title: 'Reports',
      },
      more: {
        title: 'More',
        children: {
          areas: 'Zones',
          attributes: 'Attributes',
          blacklist: 'Card Blacklist',
          extraServices: 'Extra Services',
          fares: 'Fares',
          holidays: 'Holidays',
          locations: 'Locations',
          permissions: 'Roles & Permissions',
          profiles: 'Profiles',
          rates: 'Rates',
          services: 'Services',
          shifts: 'Shifts',
          shuttles: 'Shuttles',
          sites: 'Sites',
          suppliers: 'Suppliers',
          settings: 'System Settings',
          uploadData: 'Upload Data',
          users: 'Users',
          customRules: 'Custom Rules',
          facilities: 'Facilities',
          roiSimulation: 'ROI Simulation',
        },
      },
    },
    settings: {
      myProfile: {
        button: 'My Profile',
      },
      languages: {
        button: 'Languages',
      },
      themes: {
        button: 'Change Theme',
        options: {
          light: 'Light',
          dark: 'Dark',
        },
      },
      logout: 'Logout',
    },
  },

  footer: {
    poweredBy: 'Powered by',
    moovex: 'Moovex',
  },

  asideQueue: {
    headerQueue: 'Queue',
    empty: 'No Queued Reservations Found',
    btnRemove: 'Remove from queue',
    btnAssign: 'Move to trip',
  },
};

export default layout;
